const ErrorModalIcon = (props: any) => {
    return (
        <svg width={props.width || "34"} height={props.height || "34"} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 6.375C10.7875 6.375 5.75 11.4125 5.75 17.625C5.75 23.8375 10.7875 28.875 17 28.875C23.2125 28.875 28.25 23.8375 28.25 17.625C28.25 11.4125 23.2125 6.375 17 6.375ZM17 20.125C16.5858 20.125 16.25 19.7892 16.25 19.375V15.125C16.25 14.7108 16.5858 14.375 17 14.375C17.4142 14.375 17.75 14.7108 17.75 15.125V19.375C17.75 19.7892 17.4142 20.125 17 20.125ZM17 23.75C16.5858 23.75 16.25 23.4142 16.25 23C16.25 22.5858 16.5858 22.25 17 22.25C17.4142 22.25 17.75 22.5858 17.75 23C17.75 23.4142 17.4142 23.75 17 23.75Z"
                fill={props.color || "#F04349"} />
        </svg>
    );
};

export { ErrorModalIcon };
